import "./lib/deep-link"
import { installErrorReports, installRequestIds } from "./lib/observability"
import { Toaster, TooltipProvider } from "@medusajs/ui"
import { QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router-dom"
import { queryClient } from "./lib/api"
import { router } from "./router"
import { installChunkReload } from "./lib/chunk-reload"
import { installActivityTracking } from "./lib/activity"
import "./index.css"
import "./terabizz/terabizz.css"
import "./keel/keel.css"
import "./keel/keel-dark.css"
import "./lib/theme"

installChunkReload()
// Staff are signed out after 24 hours without activity; this tells the server when the tab is in use.
installActivityTracking()
// x-request-id on every API call, and reports of the admin's own errors (lib/observability.ts).
installRequestIds()
installErrorReports()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <RouterProvider router={router} />
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>
)
